export const capitalizeFirstLetter = (value: string) => {
    const result = value.toLocaleLowerCase()
    return `${String(result).charAt(0).toUpperCase()}${String(result).slice(1)}`
}
